import { createSlice } from '@reduxjs/toolkit';

export const othSlice = createSlice({
    name: 'oth',
    initialState: {
        items: [],
        isLoading: true,
    },
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const { setItems, setIsLoading } = othSlice.actions;

export default othSlice.reducer;
